import { render, staticRenderFns } from "./PickingSendBack.vue?vue&type=template&id=5d6c5488&scoped=true&"
import script from "./PickingSendBack.vue?vue&type=script&lang=js&"
export * from "./PickingSendBack.vue?vue&type=script&lang=js&"
import style0 from "./PickingSendBack.vue?vue&type=style&index=0&id=5d6c5488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6c5488",
  null
  
)

export default component.exports